import {Component, inject, OnInit} from '@angular/core';
import {
  MatDialog} from '@angular/material/dialog';
import {AppNotification, NotificationService} from '../notification.service';
import {NotificationSendEmailComponent} from "./notification-send-email.component";

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    standalone: false
})
export class NotificationsComponent implements OnInit {
  // Injections
  public dialog: MatDialog = inject(MatDialog);
  private readonly notificationService: NotificationService = inject(NotificationService);

  notifications: Array<AppNotification>;

  openSendEmailDialog(notification: any): void {
    console.log(notification);
    const dialogRef = this.dialog.open(NotificationSendEmailComponent, {
      data: {notification: notification},
    });

    dialogRef.afterClosed().subscribe();
  }

  ngOnInit() {
    this.notifications = this.notificationService.notifications;
  }

  remove(index: number) {
    this.notificationService.removeNotification(index);
  }

  notType(notification: any) {
    let res: string;
    switch (notification.type) {
      case 'info':
        res = 'notification-info';
        break;
      case 'error':
        res = 'notification-error';
        break;
      case 'warning':
        res = 'notification-warning';
        break;
      case 'success':
        res = 'notification-success';
        break;
      default :
        res = 'notification-info';
        console.warn('Unknown notification type: \'' + notification.type + '\'');
    }
    return res;
  }

}
